import { render } from "./BreadcrumbBlock.vue?vue&type=template&id=cd54583e"
import script from "./BreadcrumbBlock.vue?vue&type=script&lang=js"
export * from "./BreadcrumbBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__